import { render, staticRenderFns } from "./BackToTop.vue?vue&type=template&id=3c829f0e&scoped=true"
import script from "./BackToTop.vue?vue&type=script&lang=ts"
export * from "./BackToTop.vue?vue&type=script&lang=ts"
import style0 from "./BackToTop.vue?vue&type=style&index=0&id=3c829f0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c829f0e",
  null
  
)

export default component.exports